/**
 * Checks if UserActivation global message should be displayed.
 * @param {Object} options.user - Fiverr Context.
 * @param {Object} options.context - Fiverr Context.
 */
export const show = ({ user, context }) => {
    const { renderUserActivationMessage, queryParameters } = context;

    return user.isPending
        && renderUserActivationMessage
        && !queryParameters.first_visit;
};
